module.exports = __webpack_public_path__ + "static/media/OpenSans-Semibold.5ef11590.svg";